<template>
  <div class="modal--consumption_data_import">
    <div class="modalCustom__header">
      <h5 class="">{{ data.header }}</h5>
      <span class="card-times" @click="closeModal">&times;</span>
      <hr class="modalCustom__header-border" />
    </div>

    <div v-if="loading">
      <MoonLoader class="loading"></MoonLoader>
    </div>
    <div v-else class="modalCustom__body">
      <div class="row">
        <h5 class="text-info">Info</h5>
        <span>
          Choose your energy supplier, with whom the API data transfer will take place. Once you have selected your
          energy supplier, click on the <span class="text-bold">Go</span> button. You will then be redirected to your
          supplier's page, where you will need to enter your account details and then choose what data you want to share
          with us. We recommend that you leave all boxes checked in order to avoid problems with getting any data. You
          will then be returned to the Consumption/Electricity page. In the table below you should see the new
          connection as well as its status.
        </span>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <label for="select_supplier" class="control-label">{{ $t('Energy Supplier') }} *</label>
          <multiselect
            v-model="energy_supplier"
            :options="energy_suppliers"
            label="name"
            id="select_supplier"
            :loading="loading"
            :multiple="false"
            :close-on-select="true"
            :show-labels="false"
          >
          </multiselect>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <p-button :disabled="!energy_supplier" type="success" @click.native.prevent="openEnergySupplierLoginPage">
            Go
          </p-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoonLoader from '@/components/svg/SvgLoaderMoon';
import EnergySupplierController from '@/controllers/Consumption/EnergySupplierController';
export default {
  name: 'GreenButtonDataImportModal',
  components: { MoonLoader },
  props: {
    data: {},
  },
  data() {
    return {
      energy_supplier: null,
      energy_suppliers: [],
    };
  },
  created() {
    this.getEnergySuppliers();
  },
  methods: {
    closeModal: function () {
      this.form = {};
      this.$emit('close');
    },
    async getEnergySuppliers() {
      this.energy_suppliers = await EnergySupplierController.index();
    },
    openEnergySupplierLoginPage() {
      window.open(this.energy_supplier.authorization_link, '_self');
    },
  },
};
</script>

<style scoped></style>
